import PropTypes from "prop-types";
import ViewGroupBulletins from "features/groups/components/ViewGroupBulletins";
import ViewContextProvider from "features/view/context/ViewContext";

const GroupBulletins = ({ groupId }) => {

  return (
    <ViewContextProvider name={ `group-bulletin/${ groupId }` }>
      <ViewGroupBulletins />
    </ViewContextProvider>
  );
}

GroupBulletins.propTypes = {
  groupId: PropTypes.number.isRequired,
}

export default GroupBulletins;
